function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 5L262 4.99998",
  stroke: "#E1E6EA",
  strokeWidth: 2,
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M259 10V0L266 5L259 10Z",
  fill: "#E1E6EA"
});
const SvgArrow = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 266,
  height: 10,
  viewBox: "0 0 266 10",
  fill: "none",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow.f644c342.svg";
export { ForwardRef as ReactComponent };